import React from "react";
import PropTypes from "prop-types";

class App extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        requestId: PropTypes.string
      })
    })
  };
  constructor(props) {
    super(props);
  }
  componentWillUnmount() {
    window.onpopstate = null;
  }
  componentDidMount() {
    window.onpopstate = this.handlePopState;
  }
  handlePopState = event => {
    //  next line tries to avoid going back and forward on browser history during the SPA live time
    window.location.reload(true);
    event.preventDefault();
  };
  render() {
    return <React.Fragment />;
  }
}
export default App;
